import type { ReactNode } from 'react';
import { Icon } from '../common';

export interface CtxCardViewAll {
  label?: string;
  onClick: () => void;
}

// The "context card" — icon + title + a count pill, over a body. THE shared
// card for the Daily context row (On duty / In residence) and the Messages day
// strip, so the head and counter read identically everywhere. The `viewAll`
// link is optional (Daily uses it to jump to the full page; the Messages strip
// omits it). `action` is an optional extra head control, sitting BEFORE the
// view-all link — opt-in, so every card that doesn't pass one is byte-identical
// to before. The body — chip fill, split, or empty-state — is the caller's.
export function CtxCard({
  icon,
  title,
  count,
  action,
  viewAll,
  children,
}: {
  icon: string;
  title: string;
  count: number;
  action?: ReactNode;
  viewAll?: CtxCardViewAll;
  children: ReactNode;
}) {
  return (
    <div className="today-ctx-card">
      <div className="today-ctx-head">
        <Icon name={icon} size={14} className="ctx-ico" />
        <span className="title">{title}</span>
        <span className="count mono">{count}</span>
        {action}
        {viewAll && (
          <button type="button" className="today-ctx-viewall" onClick={viewAll.onClick}>
            {viewAll.label ?? 'view all'} →
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
